// extracted by mini-css-extract-plugin
module.exports = {"link":"link_link__1A_GF","blue":"link_blue__4o61L"};